import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HostnameService } from '@services/hostname.service';
import { SKIP_ERROR_SNACKBAR } from '../../../../../../interceptors/http-error.interceptor';
import {
  DataSourceMessageResponse,
  DataSourceSchemaResponse,
  DataSourcesResponse,
  DataSourceTestResponse
} from '../models/data-source.model';

@Injectable()
export class DataSourcesService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(HostnameService).getOrigin();

  getDataSources(): Observable<DataSourcesResponse> {
    return this.http.get<DataSourcesResponse>(`${this.baseUrl}/api/v1/data-sources`);
  }

  createDataSource(data: Record<string, unknown>): Observable<DataSourceMessageResponse> {
    return this.http.post<DataSourceMessageResponse>(`${this.baseUrl}/api/v1/data-sources`, data, {
      context: new HttpContext().set(SKIP_ERROR_SNACKBAR, true)
    });
  }

  updateDataSource(rid: string, data: Record<string, unknown>): Observable<DataSourceMessageResponse> {
    rid = rid.replace('#', '');
    return this.http.put<DataSourceMessageResponse>(`${this.baseUrl}/api/v1/data-sources/${rid}`, data, {
      context: new HttpContext().set(SKIP_ERROR_SNACKBAR, true)
    });
  }

  deleteDataSource(rid: string): Observable<DataSourceMessageResponse> {
    rid = rid.replace('#', '');
    return this.http.delete<DataSourceMessageResponse>(`${this.baseUrl}/api/v1/data-sources/${rid}`);
  }

  testConnection(rid: string | null, body: Record<string, unknown> = {}): Observable<DataSourceTestResponse> {
    const ridParam = rid ? `?rid=${rid.replace('#', '')}` : '';
    return this.http.post<DataSourceTestResponse>(`${this.baseUrl}/api/v1/data-sources/test${ridParam}`, body);
  }

  getFormSchema(): Observable<DataSourceSchemaResponse> {
    return this.http.get<DataSourceSchemaResponse>(`${this.baseUrl}/api/v1/data-sources/schema`);
  }
}
